import { render, staticRenderFns } from "./HelpCrm.vue?vue&type=template&id=a5f9498c&scoped=true&"
import script from "./HelpCrm.vue?vue&type=script&lang=js&"
export * from "./HelpCrm.vue?vue&type=script&lang=js&"
import style0 from "./HelpCrm.vue?vue&type=style&index=0&id=a5f9498c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f9498c",
  null
  
)

component.options.__file = "HelpCrm.vue"
export default component.exports